import { Instance, flow, types, applySnapshot } from 'mobx-state-tree';

import TableData from '@common/models/TableData';

import { getPublishedReports } from '@common/api/reports';
import Report from './Report';

const Reports = types
	.compose(
		TableData,
		types.model({
			data: types.optional(types.array(Report), []),
			student_id: types.maybe(types.number),
			service_id: types.maybe(types.number),
			folder: types.maybe(types.string),
		}),
	)
	.named('Reports')
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			try {
				const result = yield getPublishedReports({
					student_id: self.student_id,
					...(self.service_id && { service_id: self.service_id }),
					...(self.folder && { folder: self.folder }),
				});
				applySnapshot(self.data, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default Reports;

export interface IReportsModel extends Instance<typeof Reports> {}
